import React from 'react';
import { Text } from 'react-native';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

export default {
    isShow: true,
    backgroundColor: 'white',
    color: baseColor.text1,
    buttonWidth: 60,
    statusBarBackgroundColor: 'white',
    height: 44,
    activeOpacity: 0.6,
    title: <Text style={{ fontSize: 18 }}>搜索结果</Text>,
    leftButtonText: (
        <Text
            style={{
                fontFamily: 'cmn_order_rn',
                fontSize: 20
            }}
        >
            &#xf07d;
        </Text>
    )
};
